import SidebarLayout from "../components/sidebarLayout";
import { Outlet, useLocation } from "react-router-dom";
import { GrCircleInformation } from "react-icons/gr";
import { LiaEnvelopeSolid, LiaPhoneVolumeSolid } from "react-icons/lia";
import Breadcrumb from "../components/breadcrumb";

export default function Settings() {
  const location = useLocation();
  const isOrderTrackingPage = location.pathname.includes("/order-tracking");
  const breadcrumbMap = {
    "/profile": ["Profile"],
    "/addresses": ["Addresses"],
    "/my-orders": ["My Orders"],
    "/favourite": ["Favourite"],
  };

  let dynamicBCrumb = [{ to: "/customer-home", title: "Home" }];

  if (location.pathname.startsWith("/order-tracking")) {
    // Special case — Order Tracking gets two crumbs before it
    dynamicBCrumb.push({ to: "/my-orders", title: "My Orders" });
    dynamicBCrumb.push({ title: "Track Order" });
  } else {
    const currentPath = Object.keys(breadcrumbMap).find((path) =>
      location.pathname.startsWith(path)
    );
    if (currentPath) {
      breadcrumbMap[currentPath].forEach((title, index) => {
        // Only the second crumb onward can be clickable if you want
        dynamicBCrumb.push({
          ...(index < breadcrumbMap[currentPath].length - 1
            ? { to: currentPath }
            : {}),
          title,
        });
      });
    }
  }

  return (
    <div className="pb-8">
      {/* Help bar */}
      <div className="flex justify-center w-full text-sm xs:text-base sm:text-xl text-[#191C1F] font-[500] gap-4 pt-3 pb-2">
        <div className="flex  items-center">
          {/* <GrCircleInformation /> */}
          <span>Need Help</span>
        </div>
        <div className="flex gap-2 items-center">
          <LiaEnvelopeSolid fontSize={24} />
          <a href="mailto:support@tydii.io" className="hover:underline">
            support@tydii.io
          </a>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="w-full bg-[#EBF9FF] px-12 py-2 mb-6">
        <Breadcrumb title="" items={dynamicBCrumb} />
      </div>

      {/* Main layout */}
      <div className="flex justify-center gap-6 mx-3 lgs:mx-12">
        {!isOrderTrackingPage && (
          <div className="hidden xl:block">
            <SidebarLayout />
          </div>
        )}
        <div className="w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
